export const getUser = state => state.account.user;
export const getUserInfo = state => state.account.userInfo;
export const isAuthenticated = state => state.account.authenticated;